<template>
  <div class="survey-question-summary">
    
    <h5 class="title is-size-5" v-if="question.header">
        {{ question.header }}
    </h5>

    <p style="white-space: pre-line">
      <span>{{ question.title }}</span>
      <span class="required" v-if="question.required">*</span>
    </p>

    <br>

    <template v-if="question.type == 'radio' || question.type == 'generated-courses'">
      <pie-chart ref="chart" :data="chartData" :messages="chartMessages" :library="chartOptions"></pie-chart>
        <text-summary
            v-if="Object.keys(comments).length > 0"
            v-model="summary"
            mode="summary"
        />
    </template>
    <template v-if="question.type == 'checkbox'">
      <bar-chart
        ref="chart"
        :data="chartData"
        :messages="chartMessages"
        :library="chartOptions"
        :discrete="true"
        label="Ответы"
      ></bar-chart>
        <text-summary
            v-if="Object.keys(comments).length > 0"
            v-model="comments"
            label="Комментарий"
        />
    </template>
    <template v-else-if="question.type == 'text'">
      <text-summary v-model="chartData"></text-summary>
    </template>
    <template v-else-if="question.type == 'short'">
      <column-chart
        ref="chart"
        :data="chartData"
        :messages="chartMessages"
        :library="chartOptions"
        :discrete="true"
        label="Ответы"
      ></column-chart>
    </template>
    
    <template v-if="question.footer">
        <br>
        <h5 class="title is-size-5">
            {{ question.footer }}
        </h5>
    </template>
  </div>
</template>

<script>
import TextSummary from "./summary/TextSummary";

var otherTitle = "Другое";

export default Vue.extend({
  props: {
    question: {
      type: Object,
      required: true
    },
    answers: {
      type: Array,
      required: true
    }
  },
  components: { TextSummary },
  data() {
    return {
      chartData: {},
      comments: {},
      summary: [],
      chartMessages: { empty: "Нет ответов" },
      chartOptions: {}
    };
  },
  mounted() {
    if (this.question.type == "checkbox") {
      this.chartOptions.chartArea = { left: "60%", right: "10%" };
    }
  },
  watch: {
    answers() {
      this.chartData = {};
      this.comments = {};

      switch (this.question.type) {
        case "generated-courses":
        case "radio": {
          _.each(this.answers, answer => {
            let title = null;

            if (this.question.type == "generated-courses") {
                title = answer.other;
            } else if (answer.answer == "other") {
              title = otherTitle;
            } else {
              title = _.get(
                _.find(this.question.options, {
                  uuid: answer.answer
                }),
                "title"
              );
            }
            this.incrementAnswer(title);
          });

          this.orderAnswers();

          this.parseComments();

          this.parseSummary();

          if (this.$refs.chart) {
            this.$refs.chart.updateChart();
          }

          break;
        }
        case "checkbox": {
          _.each(this.answers, answers => {

            let wrappedAnswer = _.isArray(answers.answer) ? answers.answer : [answers.answer]

            _.each(wrappedAnswer, answer => {
              let title = _.get(
                _.find(this.question.options, {
                  uuid: answer
                }),
                "title"
              );

              this.incrementAnswer(title);
            });
          });

          this.orderAnswers();

          this.parseComments();

          this.parseSummary();

          if (this.$refs.chart) {
            this.$refs.chart.updateChart();
          }

          break;
        }
        case "text":
        case "short": {
          _.each(_.groupBy(this.answers, "answer"), (answers, key) => {
            let uuidRegex = new RegExp(
              /^[0-9a-f]{8}-[0-9a-f]{4}-[1-5][0-9a-f]{3}-[89ab][0-9a-f]{3}-[0-9a-f]{12}$/i
            );

            if (!uuidRegex.test(key)) {
              this.chartData[key] = answers.length;
            }
          });

          // From https://stackoverflow.com/a/41875802
          this.chartData = _.sortBy(_.toPairs(this.chartData), 1).reverse();

          if (this.$refs.chart) {
            this.$refs.chart.updateChart();
          }

          break;
        }
      }
    }
  },
  methods: {
    parseSummary() {
      this.summary = [];

      for (let answer of this.answers) {
        let entry = {
          option: _.get(
            _.find(_.get(this.question, "options", []), {
              uuid: answer.answer,
            }),
            "title",
            otherTitle
          ),
          other: answer.answer == "other" ? _.get(answer, "other") : null,
          comment: _.get(answer, "comment"),
        };

        if (_.get(entry, "other") || _.get(entry, "comment")) {
          this.summary.push(entry);
        }
      }
    },
    parseComments() {
      if (!this.question.comment) {
        return;
      }

      _.each(_.groupBy(this.answers, "comment"), (answers, key) => {
        this.comments[key] = answers.length;
      });

      if (this.comments.undefined) {
        delete this.comments.undefined;
      }

      if (this.comments.null) {
        delete this.comments.null;
      }

      // From https://stackoverflow.com/a/41875802
      this.comments = _.sortBy(_.toPairs(this.comments), 1).reverse();
    },
    orderAnswers() {
      let ordered = {};

      let options = _.map(this.question.options, (o) => o.title);

      Object.keys(this.chartData)
        .sort((a, b) => {
          // Move "other" to the bottom of the list
          if (a == otherTitle || b == otherTitle) {
            return a == otherTitle
          }

          return options.indexOf(a) > options.indexOf(b);
        })
        .forEach((key) => {
          ordered[key] = this.chartData[key];
        });

      this.chartData = ordered;
    },
    incrementAnswer(title) {
      if (!title) {
        return;
      }

      this.chartData[title] = this.chartData[title]
        ? this.chartData[title] + 1
        : 1;
    }
  }
});
</script>



// WEBPACK FOOTER //
// resources/assets/js/components/survey/QuestionSummary.vue